import '../utils/jquery-extensions';
import util from './utils';
import globalUtil from '../utils/util';
import refinementsUtil from '../utils/refinements';
import priceSlider from './priceslider';
import uniform from '../components/uniform';
import dyTracking from '../components/tracking/dytracking';
import optiExperiment from '../components/optimizelyExperimentation';
import tracking from '../components/tracking/tracking';
import ConstructorIOSearch from '../constructor-io/search';
import {
    handleClearAllRefinements as handleClearAllRefinementsConstructor,
    handleNonInstantRefinementSelection as handleNonInstantRefinementSelectionConstructor,
    handleRefinements as handleRefinementsConstructor
} from '../constructor-io/search/event-handlers';
import {isRefinedSearch as isRefinedSearchConstructor} from '../constructor-io/helpers/search';
import {calculateBottomContentHeight} from './common';

var defaults = {
    refinementParamName: 'prefn{n}',
    refinementParamValue: 'prefv{n}',
    refinementRootSelector: '.refinement-flyin',
    refinementGroupSelector: '.refinement[data-attrid]',
    refinementFiltersRootSelector: '.refinements-filters',
    selectedRefinementValueSelector: '.selected:not(.region-select)',
    btnApplySelector: '#refinements-apply',
    btnClearAllSelector: '.refinements-clear-all',
    preselectedClass: 'selected',
    noHitsClass: 'no-hits',
    noRefinementsClass: 'no-refinements',
    selectionChangedClass: 'selection-changed',
    // use apply button below this viewport width, update listing instantly above it.
    instantUpdateViewportThreshold: 1024
};

var settings = {};
var expandedRefinements = {};
var expandedShowMore = {};

function buildRefinementParams(refinements) {
    const params = {};
    Object.keys(refinements).forEach(function (id, i) {
        if (Array.isArray(refinements[id])) {
            params[settings.refinementParamName.replace(/{n}/, i + 1)] = id;
            params[settings.refinementParamValue.replace(/{n}/, i + 1)] = refinements[id].join('|');
        } else {
            params[id] = refinements[id];
        }
    });

    return params;
}

/**
 * Gets params to keep while modifying the URL.
 *
 * @param {Object} scope - scope object.
 * @returns {Object} params to keep
 */
const getParamsToKeep = scope => {
    const currentParams = util.getQueryStringParams(window.location.search || '');

    const paramsToKeep = {};

    if (currentParams.cgid) {
        paramsToKeep.cgid = currentParams.cgid;
    } else if (scope.dataset.category && scope.dataset.category !== 'null') {
        paramsToKeep.cgid = scope.dataset.category;
    }

    if (currentParams.q) {
        paramsToKeep.q = currentParams.q;
    }

    if (currentParams.srule) {
        paramsToKeep.srule = currentParams.srule;
    }

    // Apply stored size region if set.
    const storedRegion = localStorage.getItem('selectedRegion');

    if (storedRegion) {
        paramsToKeep.region = storedRegion;
    }

    return paramsToKeep;
};

const buildRefineUrl = (baseUrl, params, scope, lastFilterSet) => {
    const paramsToKeep = getParamsToKeep(scope);
    const newParams = buildRefinementParams(refinementsUtil.getSelectedRefinements(scope));

    if (lastFilterSet) {
        newParams['lastfilterset'] = lastFilterSet;
    }

    return baseUrl + '?' + util.objectToQueryString(Object.assign({}, paramsToKeep, newParams, params || {}));
};

function afterUpdateProductListing(e) {
    setSizeRegion();
    window.removeEventListener('plp.updateproductlisting.done', afterUpdateProductListing);
    setTimeout(function () {
        window.scrollTo(0, e.detail.offset);
    }, 300);
}

/**
 * As an action by clicking a refinement link we rerender all the filters
 * this function will find a new link for the same refinement and set focus to
 * it for accessibility reasons
 *
 * @param {Object?} fakeInitiatorLink  - the original link that was clicked on
 */
function refocusRerenderedRefinementLink(fakeInitiatorLink) {
    if (!fakeInitiatorLink) {
        return;
    }
    const initiatorId = fakeInitiatorLink.attr('id');
    let fakeLink;
    if (initiatorId) {
        fakeLink = $(`#${initiatorId}`);
    } else {
        const initiatorTitle = fakeInitiatorLink.attr('title');
        fakeLink = $(`[title="${initiatorTitle}"]`);
    }

    if (fakeLink[0]) {
        setTimeout(() => {
            fakeLink[0].focus({focusVisible: true, preventScroll: true});
        }, 0);
    }
}

async function onRefinementChange(event, trigger, action, root) {
    event.preventDefault();

    const instantUpdate =
        action === 'apply' || action === 'clear' || window.innerWidth >= settings.instantUpdateViewportThreshold;

    const $trigger = $(trigger);
    const fakeInitiatorLink = $trigger.find('[role=link]');

    const $triggerElement = $trigger
        .parents('.refinement')
        .find("[data-refinement-value='" + $trigger.attr('data-refinement-value') + "']");

    const baseUrl = instantUpdate ? util.getBaseUrl() : root.dataset.countUrl;

    let updateUrl;
    let refinementForTrackingString = '';
    let refinementsForTrackingString = '';
    let refinementKey = '';
    let refinementValues = [];
    let refinementPresentationId = '';
    let refineAction = '';
    let selectedRefinements;

    if (action === 'refine') {
        let selected =
            $trigger.hasClass('selected') || $trigger.data('isSelected') || $trigger.hasClass('refinement-relax');
        let refinementInfo = $trigger.attr('data-refinement-info');
        refineAction = selected ? 'remove' : 'add';
        refinementKey = $trigger.attr('data-refinement-id') || $trigger.parents('.refinement').attr('data-attrid');
        let singleRefinementValue = $trigger.attr('data-refinement-value');
        refinementValues = $trigger.data('refinementValues');
        refinementPresentationId = $trigger.data('presentationId');
        if (refinementPresentationId) {
            singleRefinementValue = refinementPresentationId;
        }
        if (refinementKey) {
            if (singleRefinementValue) {
                refinementValues = [refinementForTracking(refinementKey, singleRefinementValue)];
            } else if (refinementValues && refinementValues.length) {
                refinementValues = refinementValues.map(function (value) {
                    return refinementForTracking(refinementKey, value);
                });
            }

            if (refinementValues && refinementValues.length) {
                refinementForTrackingString = refinementKey.split('_')[0] + '|' + refinementValues.join(', ');
            }
        }

        if (!selected) {
            const parent = $trigger.closest('li.refinement');
            const filterContainer = parent.find('input[name="filterType"]');
            const lang = $('input[name="lang"]').val();

            if (filterContainer && filterContainer.length) {
                const defaultValue = dyTracking.mapFilters(refinementInfo, lang, filterContainer.val());
                const isLocalizable = dyTracking.isLocalizableFilter(filterContainer.val());
                if (!isLocalizable) {
                    dyTracking.filterItems(defaultValue, `${filterContainer.val()}`);
                } else {
                    dyTracking.filterItems(defaultValue, `lng:${lang}:${filterContainer.val()}`);
                }
            }
        }

        $triggerElement.toggleClass(settings.preselectedClass);

        if (ConstructorIOSearch.isEnabled || $trigger.hasClass('refinement-relax')) {
            updateUrl =
                trigger.href ||
                trigger.getAttribute('data-href') ||
                trigger.querySelector('.value-link').href ||
                trigger.querySelector('.value-link')?.getAttribute('data-href');
        } else {
            updateUrl = buildRefineUrl(baseUrl, {}, root, refinementInfo); // getCount = true;
        }
    } else if (action === 'refine_price' && trigger.length === 2) {
        var min = Math.min(trigger[0].value, trigger[1].value);
        var max = Math.max(trigger[0].value, trigger[1].value);
        updateUrl = buildRefineUrl(
            baseUrl,
            {
                pmin: min,
                pmax: max
            },
            root,
            $trigger.attr('data-refinement-info')
        ); // getCount = true;
    } else if (action === 'apply') {
        updateUrl = buildRefineUrl(baseUrl, {}, root, $trigger.attr('data-refinement-info'));
    } else if (action === 'clear') {
        updateUrl = trigger.dataset.url;
        if (!instantUpdate) {
            if ($('html').hasClass('refinements-active')) {
                $('.refinements-filters .refinement-close').click();
            }
        }
    } else if (action === 'cancel') {
        updateUrl = trigger.dataset.currentUrl;
        trigger.classList.add('active');
    } // Set the selected refinement as temp (not applied yet)

    if (trigger.length) {
        trigger.forEach(function (current) {
            current.classList.add('refinement-temp');
        });
    } else {
        trigger.classList.add('refinement-temp');
    } // Apply or clear refinements

    selectedRefinements = refinementsUtil.getSelectedRefinements(root, true);
    refinementsForTrackingString = refinementsForTracking(
        selectedRefinements,
        refinementKey,
        refinementValues,
        refineAction
    );

    if (instantUpdate) {
        if (ConstructorIOSearch.isEnabled && action === 'refine') {
            const numberOfResults = await handleRefinementsConstructor(ConstructorIOSearch, null, null, updateUrl);
            tracking.plpFilterChange(
                refineAction,
                refinementForTrackingString,
                refinementsForTrackingString,
                numberOfResults
            );
        } else if (ConstructorIOSearch.isEnabled && action === 'clear') {
            const numberOfResults = await handleClearAllRefinementsConstructor(ConstructorIOSearch, updateUrl);
            tracking.plpFilterChange('remove_all', '', refinementsForTrackingString, numberOfResults);
        } else if (ConstructorIOSearch.isEnabled && action === 'apply') {
            const paramsToKeep = getParamsToKeep(root);
            const applyUrl = baseUrl + '?' + util.objectToQueryString(Object.assign({}, paramsToKeep));

            await handleRefinementsConstructor(ConstructorIOSearch, trigger, selectedRefinements, applyUrl);
        } else {
            if (action === 'clear') {
                refineAction = 'remove_all';
            }

            let trackingData = {
                refineAction,
                refinementForTrackingString,
                refinementsForTrackingString
            };

            const updateEvent = new CustomEvent('plp.updateproductlisting', {
                bubbles: true,
                cancelable: false,
                detail: {
                    trackingData
                }
            });
            updateEvent.afterRerenderCallback = () => {
                refocusRerenderedRefinementLink(fakeInitiatorLink);
            };
            window.history.pushState(window.history.state, document.title, updateUrl);
            window.dispatchEvent(updateEvent);
        }
    } else {
        if (ConstructorIOSearch.isEnabled && action === 'refine') {
            const numberOfResults = await handleNonInstantRefinementSelectionConstructor(
                ConstructorIOSearch,
                trigger,
                selectedRefinements
            );
            tracking.plpFilterChange(
                refineAction,
                refinementForTrackingString,
                refinementsForTrackingString,
                numberOfResults
            );
            if (Object.keys(selectedRefinements).length > 0 || isRefinedSearchConstructor()) {
                document
                    .querySelector(settings.refinementFiltersRootSelector)
                    ?.classList.add(settings.selectionChangedClass);
            }
            return;
        } else if (ConstructorIOSearch.isEnabled && action == 'cancel') {
            // return the refinements to the previous state since the selected refinements were not applied
            await handleNonInstantRefinementSelectionConstructor(ConstructorIOSearch, null, null, updateUrl);
            return;
        }
        // Collect the currently expanded refinements
        $('.refinements-list > [data-attrid]').each(function () {
            var $this = $(this);
            expandedRefinements[$this.attr('data-attrid')] = $this.find('.toggle').hasClass('expanded');
            expandedShowMore[$this.attr('data-attrid')] = $this.find('.show-more').hasClass('expanded');
        });

        // Update refinements list
        $.get(updateUrl, function (html) {
            var $html = $('<div>' + html + '</div>');
            var $refinementsList = $('.refinements-list');
            $refinementsList.html('');

            var selectedFilters = $html.find('.selected-refinements-ctr');

            if (selectedFilters && selectedFilters.length) {
                $('.selected-refinements-ctr').remove();
                selectedFilters.appendTo($refinementsList);
            }

            // Populate the refinements
            $html.find('.refinements-list > [data-attrid]').each(function () {
                $(this).appendTo($refinementsList);
                $('.color-bubble').removeClass('color-bubble--background-hidden');
            });

            // Re-set the toggles events
            $('.refinements-list > .refinement').each(function () {
                var $refinement = $(this);
                var $toggle = $refinement.find('> .refinement-dropdown > .toggle');
                var $toggleContent = $refinement.find('> .refinement-dropdown > .toggle-content');

                //Show more toggle
                $refinement
                    .find('.show-more')
                    .off('click')
                    .on('click', function () {
                        var $this = $(this);
                        var isExpanded = $this.hasClass('expanded');
                        var $toggleMoreContent = $this.siblings('.toggle-content');
                        var $labelMore = $this.find('.toggle-label-more');
                        var $labelLess = $this.find('.toggle-label-less');

                        if (isExpanded) {
                            $toggleMoreContent.slideUp(300, function () {
                                $this.removeClass('expanded');
                                $labelMore.show().attr('aria-hidden', 'false');
                                $labelLess.hide().attr('aria-hidden', 'true');
                            });
                        } else {
                            $toggleMoreContent.slideDown(300, function () {
                                $this.addClass('expanded');
                                $labelMore.hide().attr('aria-hidden', 'true');
                                $labelLess.show().attr('aria-hidden', 'false');
                            });
                        }
                    });

                if (expandedRefinements[$refinement.attr('data-attrid')] === true) {
                    $toggle.addClass('expanded');
                } else if (expandedRefinements[$refinement.attr('data-attrid')] === false) {
                    $toggle.removeClass('expanded');
                }

                if (expandedShowMore[$refinement.attr('data-attrid')] === true) {
                    $refinement.find('.show-more').addClass('expanded');
                    $refinement.find('.refinement-dropdown-more .toggle-content').show();
                    $refinement.find('.toggle-label-more').hide().attr('aria-hidden', 'true');
                    $refinement.find('.toggle-label-less').show().attr('aria-hidden', 'false');
                } else {
                    $refinement.find('.show-more').removeClass('expanded');
                    $refinement.find('.refinement-dropdown-more .toggle-content').hide();
                    $refinement.find('.toggle-label-more').show().attr('aria-hidden', 'false');
                    $refinement.find('.toggle-label-less').hide().attr('aria-hidden', 'true');
                }

                if ($toggle.hasClass('expanded')) {
                    $toggleContent.show();
                } else {
                    $toggleContent.hide();
                }

                initOptimizelyExperiments();
            });

            uniform();
            initPriceSlider();

            var btnApply = document.body.querySelector(settings.btnApplySelector);
            var refinementCancelTriggerred = $('.refinement-close').hasClass('active');
            var count = $html.find('[data-product-count]').data('productCount');
            // Update the apply button label
            if (btnApply && count) {
                var btnLabel = $html.find(settings.btnApplySelector).find('.refinements-apply-label').html();
                $(btnApply).find('.refinements-apply-label').html(btnLabel);
                btnApply.classList.toggle(settings.noHitsClass, !!!count);
            }

            tracking.plpFilterChange(refineAction, refinementForTrackingString, refinementsForTrackingString, count);

            if (count) {
                root.classList.toggle(settings.noRefinementsClass, !!!count);
            }

            if (refinementCancelTriggerred) {
                $('.refinement-close').removeClass('active');
            } else {
                root.classList.add(settings.selectionChangedClass);
                refocusRerenderedRefinementLink(fakeInitiatorLink);
            }
        });
    }
}

function rememberRefinementState(attrID, expanded) {
    var filtersState = localStorage.getItem('filter_type_state');

    if (!filtersState) {
        filtersState = {
            expanded: [],
            collapsed: []
        };
    } else {
        filtersState = JSON.parse(filtersState);
    }

    var indexCollapsed = filtersState.collapsed.indexOf(attrID);
    var indexExpanded = filtersState.expanded.indexOf(attrID);

    if (expanded) {
        if (indexExpanded == -1) {
            filtersState.expanded.push(attrID);
        }

        if (indexCollapsed > -1) {
            filtersState.collapsed.splice(indexCollapsed, 1);
        }
    } else {
        if (indexCollapsed == -1) {
            filtersState.collapsed.push(attrID);
        }

        if (indexExpanded > -1) {
            filtersState.expanded.splice(indexExpanded, 1);
        }
    }

    localStorage.setItem('filter_type_state', JSON.stringify(filtersState));
}

/**
 *  Convert refinement value to suitable for tracking
 *
 * @param {String} refinementKey
 * @param {String} refinementValue
 * @returns {String} refinement value clean for tracking
 */
function refinementForTracking(refinementKey, refinementValue) {
    refinementValue = decodeURIComponent(refinementValue.toString());
    if (refinementKey.includes('refinementColor') || refinementKey.includes('upperMaterial')) {
        refinementValue = refinementValue.replace(/(^\")|(\"$)/g, ''); // some values in constructor like color has extra quotes at start and end exmp "001"
    }
    return refinementValue;
}

/**
 * Get refinements for tracking string
 *
 * @param {Object} allRefinements all selected refinements object
 * @param {String} selectedRefinementKey selected refinement key
 * @param {Array} selectedRefinementValues selected refinement values
 * @param {String} refineAction  refine action (add or remove)
 * @returns {String} refinementsForTracking string example: 'sizeName|40;7, sizeName|45;10.5, width|S'
 */
function refinementsForTracking(allRefinements, selectedRefinementKey, selectedRefinementValues, refineAction) {
    let refinementsForTracking = [];
    for (let refinementKey in allRefinements) {
        let refinementValues = allRefinements[refinementKey];
        let refinement = refinementKey.split('_')[0]; // remove language sizeName_NL
        refinementValues.forEach(function (refinementValue) {
            if (
                refineAction === 'remove' &&
                refinementKey === selectedRefinementKey &&
                selectedRefinementValues.indexOf(refinementValue) > -1
            ) {
                return; // don't add the currently removed refinement
            }
            refinementValue = refinementForTracking(refinementKey, refinementValue);
            refinementsForTracking.push(refinement + '|' + refinementValue);
        });
    }
    return refinementsForTracking.join(', ');
}

function refinementContainerListener(event) {
    var toggleRefinements = event.target.closest('.refinement-select');
    var refinementEl = event.target.closest('[data-refinement-value],[data-refinement-values]');
    var btnClear = event.target.closest(settings.btnClearAllSelector);
    var btnCancel = event.target.closest('.refinement-close');
    var refinementSelectInner = event.target.closest('.refinement-select-inner');
    var regionSelect = refinementSelectInner ? refinementSelectInner.querySelector('.regions') : null;
    var btnSizeRemove = event.target.closest('.refinement-size-remove');
    var action;
    let isSize = !!$(event.target).closest('.sizes').length;

    if (isSize) {
        optiExperiment.trackEvent('shoe_size_selector_click');
    }
    if (btnSizeRemove) {
        var sizeRefValue = $(btnSizeRemove).data()['refinementsizevalue'];
        var filterSizes = $('.sizes');

        if (filterSizes.length > 0) {
            var removeSizeEl = filterSizes.find("[data-refinement-value='" + sizeRefValue + "']");
            if (removeSizeEl.length > 0) {
                event.preventDefault();
                event.stopPropagation();

                removeSizeEl.eq(0).click();
            }
        }
    } else if (refinementEl && !refinementEl.classList.contains('unselectable')) {
        // if a refinement link was clicked.
        event.preventDefault();
        event.stopPropagation();
        action = 'refine';
    } else if (btnClear) {
        // if the 'Clear All' button was clicked.
        event.preventDefault();
        refinementEl = btnClear;
        action = 'clear';
    } else if (btnCancel) {
        refinementEl = btnCancel;
        action = 'cancel';
    } else if (
        regionSelect &&
        event.target.className !== 'refinement-select-inner' &&
        event.target.className !== 'plus-minus-icon'
    ) {
        // remember the last selected size region
        const regionEl =
            event.target.closest('.region-select') ||
            event.target.closest('.refinement-select-inner').querySelector('.region-select');
        const region = regionEl.dataset.region;
        localStorage.setItem('selectedRegion', region);
        const {searchParams} = new URL(window.location.href);
        searchParams.set('region', region);
        $('.region-select').find('.input-radiobutton').removeAttr('checked');
        $(regionEl).find('.input-radiobutton').attr('checked', 'checked');
        $('.region-select').removeClass('selected');
        $(regionEl).addClass('selected');
    } else if (toggleRefinements) {
        var attrID = toggleRefinements.closest('[data-attrid]').dataset.attrid;
        var isClosing = $(toggleRefinements).hasClass('expanded') || $(toggleRefinements).hasClass('expanded-desktop');
        var isExpanded = !isClosing;
        rememberRefinementState(attrID, isExpanded);
    }

    if (action) {
        onRefinementChange(event, refinementEl, action, event.currentTarget);
    }
}

function selectSizeRegion(region) {
    const $sizeDropdown = $('.refinement.sizeName');

    $sizeDropdown.find('.RegionGroup').each(function () {
        const regionID = $(this).attr('id');
        const $regionGroup = $sizeDropdown.find('.regions [data-region="' + regionID + '"] .radio > span');
        const $regionEl = $sizeDropdown.find('.regions [data-region="' + regionID + '"]');
        if (regionID === region) {
            $(this).addClass('active');
            $regionGroup.addClass('checked');
            $regionGroup.find('.input-radiobutton').attr('checked', 'checked').attr('aria-checked', 'true');
            $regionEl.addClass('selected');
        } else {
            $(this).removeClass('active');
            $regionGroup.removeClass('checked');
            $regionGroup.find('.input-radiobutton').removeAttr('checked').attr('aria-checked', 'false');
            $regionEl.removeClass('selected');
        }
    });
}

function setSizeRegion() {
    const {searchParams} = new URL(window.location.href);
    const storedRegion = searchParams.get('region') || localStorage.getItem('selectedRegion');
    const checkedRegion = $('.region-select #' + storedRegion + '-desktop');
    //set only if stored
    const $sizeDropdown = $('.refinement.sizeName');
    if (storedRegion && checkedRegion.length) {
        selectSizeRegion(storedRegion);

        if (checkedRegion && checkedRegion.attr('checked') !== 'checked') {
            setTimeout(setSizeRegion, 200);
        }
    } else {
        const $regionEl = $sizeDropdown.find('.regions .region-select').first();
        const $regionGroup = $regionEl.find('.radio > span');
        $regionGroup.addClass('checked');
        $regionGroup.find('.input-radiobutton').attr('checked', 'checked').attr('aria-checked', 'true');
        $regionEl.addClass('selected');
        $sizeDropdown.find('.RegionGroup').first().addClass('active');
    }
}

function initPriceSlider() {
    var priceRangeEl = document.getElementById('price-range-slider');
    var priceMinInput = document.getElementById('price-min-value');
    var priceMaxInput = document.getElementById('price-max-value');
    if (priceRangeEl) {
        priceSlider(priceRangeEl, priceMinInput, priceMaxInput, onRefinementChange);
    }
}

function sizeLabelHandler(e) {
    if (globalUtil.isClickOrSpaceOrEnter(e)) {
        $('.region-select').find('.input-radiobutton').removeAttr('checked');
        $('#' + $(this).attr('for')).attr('checked', 'checked');
    }
}

function regionSelectADAHandler(event) {
    if (globalUtil.isClickOrSpaceOrEnter(event)) {
        $('.region-select').find('.input-radiobutton').attr('aria-checked', 'false');
        $('.region-select').find('.js-size-label').attr('aria-checked', 'false');

        $(this).find('.input-radiobutton').attr('aria-checked', 'true');
        $(this).find('.js-size-label').attr('aria-checked', 'true');

        $('.region-select').removeClass('selected');
        $(this).addClass('selected');
    }
}

function applyButtonHandler(e) {
    $('.refinement-temp').removeClass('refinement-temp');
    e.preventDefault();
    onRefinementChange(
        e,
        e.currentTarget,
        'apply',
        document.body.querySelector(settings.refinementFiltersRootSelector)
    );
}

/**
 * Logic if we don't have category description teaser when calculating the refinement overlap.
 *
 * @param {JQuery} $main - main tag
 * @param {JQuery} $footer - footer tag
 * @param {number} lastRefinementEnd - position where the last refinement ends
 */
const calculateMainHeight = ($main, $footer, lastRefinementEnd) => {
    const mainHeight = $main.outerHeight();
    if ($main.attr('data-original-height') === undefined) {
        $main.attr('data-original-height', mainHeight);
    }
    const footerStart = $footer.offset().top;
    const alreadyExisting = $main.attr('data-down-height');
    let diff = 0;
    let newHeight = 0;
    if (lastRefinementEnd > footerStart) {
        diff = lastRefinementEnd - footerStart;
        newHeight = mainHeight + diff;
    } else if (alreadyExisting && alreadyExisting !== '0') {
        diff = footerStart - lastRefinementEnd;
        newHeight = mainHeight - diff;
    }
    if (diff && newHeight) {
        $main.attr('data-down-height', diff);
        $main.height(newHeight);
    }
};

function regionToggleHandler(e) {
    if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
        const regionsClassList = ['label', 'input-radiobutton'];
        const targetClassList = e.target.classList;
        const isRegionsClicked =
            targetClassList.contains(regionsClassList[0]) || targetClassList.contains(regionsClassList[1]);
        //Prevent collapsing refinement list if regions are clicked
        if (isRegionsClicked) {
            return;
        }

        const $toggle = $(this);
        const isExpanding = !$toggle.hasClass('expanded');

        e.preventDefault();
        e.stopImmediatePropagation();

        if (window.stickySidebar) {
            window.stickySidebar.direction = 'down';
        }

        const lastRefinement = $('.refinements-list li.refinement:last-child');
        const $toggleContent = $toggle.siblings('.toggle-content');
        const $main = $('main');
        const $footer = $('footer');
        const $bottom = $('#bottomcontent');
        const categoryText = $bottom.find('.bottom-category-description');

        $toggleContent[isExpanding ? 'slideDown' : 'slideUp']({
            duration: 300,
            progress: () => {
                if (lastRefinement.length) {
                    const lastRefinementEnd = lastRefinement.offset().top + lastRefinement.height();
                    // Precalculate height only if the last refinement is overlapping the footer text.
                    if ($bottom.length && categoryText.length) {
                        calculateBottomContentHeight($bottom, lastRefinementEnd);
                    } else {
                        // Logic if we don't have category description teaser.
                        calculateMainHeight($main, $footer, lastRefinementEnd);
                    }
                }
            }
        });
        $toggle.toggleClass('expanded');
        $toggle.attr('aria-expanded', isExpanding ? 'true' : 'false');
    }
}

function selectRefinementHandler() {
    var attrID = $(this).parents('.refinement').data('attrid');
    var isExpanded = $(this).hasClass('expanded') || $(this).hasClass('expanded-desktop');
    if (attrID) {
        rememberRefinementState(attrID, isExpanded);
    }
    if (isExpanded) {
        $(this).attr('aria-expanded', 'true');
    }
}

function resumeColorBackgrounds() {
    const lazyImages = document.querySelectorAll('.color-bubble--background-hidden');

    const backgroundOptions = {
        threshold: 0,
        rootMargin: '0px 0px 50px 0px'
    };

    const imageObserver = new IntersectionObserver((entries, imageObserver) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                showImageBackground(entry.target);
                imageObserver.unobserve(entry.target);
            }
        });
    }, backgroundOptions);

    lazyImages.forEach(image => {
        imageObserver.observe(image);
    });

    function showImageBackground(node) {
        node.classList.remove('color-bubble--background-hidden');
    }
}

async function initOptimizelyExperiments() {
    const result = await optiExperiment.decideFeatureFlagVariation('pdp');

    if (result.variationKeySizing === 'treatment_2') {
        $('.nav-tabs-regions-selector').hide();
        $('.swatches').addClass('m-feature-testing-combined m-feature-testing-combined-vertical');
        $('.region-select#US-group').find('.tab-link').trigger('click');
    } else if (result.variationKeySizing === 'treatment_3') {
        $('.nav-tabs-regions-selector').hide();
        $('.swatches').addClass('m-feature-testing-combined m-feature-testing-combined-horizontal');
        $('.region-select#US-group').find('.tab-link').trigger('click');
    }
}

function init(scope, options) {
    settings = Object.assign({}, defaults, options || {});

    const refinementContainers = scope.querySelectorAll(settings.refinementRootSelector);

    for (let i = 0; i < refinementContainers.length; i++) {
        refinementContainers[i].addEventListener('click', function (event) {
            refinementContainerListener(event);
        });

        refinementContainers[i].addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                refinementContainerListener(event);
            }
        });

        // price range sliders and checkboxes
        refinementContainers[i].addEventListener('change', function (event) {
            var isOption = event.target.matches('.refinement-option');
            if (isOption) {
                action = 'refine';
                onRefinementChange(event, event.target, action, event.currentTarget);
            }
        });
    }

    $('body').on('click keypress', '.js-size-label', sizeLabelHandler);

    // ADA aria-checked
    $('body').on('click keypress', '.region-select', regionSelectADAHandler);

    var btnApply = document.body.querySelector(settings.btnApplySelector);
    if (btnApply) {
        // if the 'Apply' button was clicked, apply the filters and update the product listing.
        btnApply.addEventListener('click', applyButtonHandler);
    }

    initPriceSlider();
    uniform();
    initOptimizelyExperiments().finally(() => {
        setSizeRegion();
    });
    resumeColorBackgrounds();

    // Update the sticky sidebar when the refinement accordions are toggled
    $('body').on('click keydown', '.refinements .toggle', regionToggleHandler);
    $('.refinement-select:not(.show-more)').each(selectRefinementHandler);
    window.addEventListener('plp.updateproductlisting.done', afterUpdateProductListing);

    $('.refinement-select').on('click', '.radio', function () {
        optiExperiment.trackEvent('size_selector_click');
    });
}

exports.init = init;
